// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getJobPaymentRequestsClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetJobPaymentRequestsClientApi = createAsyncThunk(
  "hitGetJobPaymentRequestsClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getJobPaymentRequestsClient;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetJobPaymentRequestsClientSlice = createSlice({
  name: "getJobPaymentRequestsClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetJobPaymentRequestsClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetJobPaymentRequestsClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetJobPaymentRequestsClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetJobPaymentRequestsClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetJobPaymentRequestsClientData } = GetJobPaymentRequestsClientSlice.actions;
export default GetJobPaymentRequestsClientSlice.reducer;
